import { withManagedProps } from "@made-people/managed-props";
import { CentraSearchResultsProviderProps } from "@made-people/grease-centra";
import { ProductTemplateAsSalzburgProps } from "@made-people/blueprint-product";
import { QuickShopWithSiblings } from "./QuickShopWithSiblings";
import { QuickShopProductSwitcher } from "./QuickShopProductSwitcher";

export const ProductQuickshop = withManagedProps(
  "ProductQuickshop",
  (
    props: CentraSearchResultsProviderProps & {
      heading?: string;
      description?: string;
      variants?: ProductTemplateAsSalzburgProps["variants"];
    },
  ) => {
    const productsPayload = props.payload.products;
    if (productsPayload && typeof productsPayload === "string") {
      props.payload.products = (productsPayload as string).split(",");
    }

    return (
      <QuickShopWithSiblings initialPayload={props.payload}>
        {(products) => (
          <QuickShopProductSwitcher
            products={products}
            heading={props?.heading}
            description={props?.description}
            variants={props.variants}
          />
        )}
      </QuickShopWithSiblings>
    );
  },
);
